import './pdf-progress-bar.scss'

import { faCheck, faClipboard, faCube, faPenFancy, faSearch } from '@fortawesome/free-solid-svg-icons';
import Component from 'vue-class-component';

import { CrPDFSection } from '@skinsoft/types';
import { ReactiveVue } from '@skinsoft/reactive-vue';

import { PDF_STEP_COMPLETE_TOPIC } from '../../../busTopics';

declare const config
const SECTIONS_ORDER: CrPDFSection[] = config.conditionReportPDFGenerator.sections.order

@Component({
    template: require('./pdf-progress-bar.html')
})
export class PDFProgressBar extends ReactiveVue {

    // Icons
    private objectIcon = faCube;
    private generalOverviewIcon = faClipboard;
    private defectsIcon = faSearch;
    private observationsIcon = faClipboard;
    private contextIcon = faPenFancy;
    private successIcon = faCheck;

    private currentStep = 1;

    public mounted() {
        this.subscribeToBus(PDF_STEP_COMPLETE_TOPIC, (message) => {
            this.currentStep = message.payload.step + 1 // we add 1 to show the icons for the step that is
                                                        // currently being generated and not the one that just
                                                        // finished being generated
        })
    }

    private getTitleFromStep(step: number) {
        switch(SECTIONS_ORDER[step-1].type) {
            case "alteration":
                return this.$t('pdfOverviewScreen.progressBar.defects') as string
            case "context":
                return this.$t('pdfOverviewScreen.progressBar.contextAndSignatures') as string
            case "item":
                return this.$t('pdfOverviewScreen.progressBar.object') as string
            case "report":
                return this.$t('pdfOverviewScreen.progressBar.generalDigest') as string
        }
    }

    private getIconFromStep(step: number) {
        switch(SECTIONS_ORDER[step-1].type) {
            case "alteration":
                return this.defectsIcon
            case "context":
                return this.contextIcon
            case "item":
                return this.objectIcon
            case "report":
                return this.generalOverviewIcon
        }
    }

    private getIconClassFromStep(index) {
        if (index === this.currentStep) {
            if (index === 5) {
                return 'current-complete-step-icon'
            } else {
                return 'current-step-icon'
            }
        } else if (index < this.currentStep) {
            return 'complete-step-icon'
        } else {
            return 'step-icon'
        }
    }

    private getLineClassFromStep(index) {
        if (index <= this.currentStep) {
            return 'complete-svg-line'
        } else {
            return 'svg-line'
        }
    }

    private isCurrentStep(index) {
        return index === this.currentStep;
    }

}